import script from "./InfoBox.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBox.vue?vue&type=script&setup=true&lang=js"

import "./InfoBox.vue?vue&type=style&index=0&id=10e02149&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10e02149"]])

export default __exports__